import { footerStats, navLinks } from "@/mocks/homeContent";

export default function FooterSection() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-50 text-lg text-secondary-900">
                <i className="ri-book-read-line"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight">
                善良的女秘书
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-100">
              本站为一个围绕「善良的女秘书」主题整理信息的中文单页站，集中呈现作品概况、剧情主题、主要人物、内容结构与观看方式说明，方便访客一页读懂并快速定位所需内容。
            </p>
            <div className="mt-6 flex flex-wrap gap-6">
              {footerStats.map((s) => (
                <div key={s.label}>
                  <p className="font-heading text-2xl font-bold text-background-50">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-secondary-200">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-sm font-semibold text-background-50">
              本页导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="inline-flex items-center gap-1.5 text-sm text-secondary-100 transition-colors hover:text-background-50"
                  >
                    <span className="flex h-3.5 w-3.5 items-center justify-center text-accent-300">
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-semibold text-background-50">
              关于本页
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100">
              本页仅提供主题相关的信息整理与常识性说明，不涉及账号、支付或数据提交。页面内容为一般性描述，如有出入以实际情况为准。
            </p>
            <a
              href="#home"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-50 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-background-100"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-up-line"></i>
              </span>
              回到页面顶部
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-200 sm:flex-row">
          <p>© 2026 善良的女秘书 · 单页信息站</p>
          <p>内容整理 · 信息参考 · 仅供浏览</p>
        </div>
      </div>
    </footer>
  );
}